//
// locales/vanilla/vi.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/vi.json';
import localeData from 'react-intl/locale-data/vi.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
